// extracted by mini-css-extract-plugin
export var closeButton = "_redotech-redo-web-src-marketing-signup-form-close-button";
export var formContent = "_redotech-redo-web-src-marketing-signup-form-form-content";
export var imageSection = "_redotech-redo-web-src-marketing-signup-form-image-section";
export var imageSectionPlaceholder = "_redotech-redo-web-src-marketing-signup-form-image-section-placeholder";
export var inputBox = "_redotech-redo-web-src-marketing-signup-form-input-box";
export var invertedTextColor = "_redotech-redo-web-src-marketing-signup-form-inverted-text-color";
export var legalDisclaimer = "_redotech-redo-web-src-marketing-signup-form-legal-disclaimer";